import React, { useEffect, useState } from 'react'
import { Form, Table, Tag } from "antd";

export default function Organisations({ data }) {
  const [organisations, setOrganisations] = useState([]);

  const [form] = Form.useForm();
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      defaultSortOrder: "ascend",
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      render: (record) => {
        return (
          <>
            {record.value}
          </>
        );
      },
    },
    {
      title: "Contact Number",
      dataIndex: "telephone",
      key: "telephone"
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
      render: ( address ) => {
        return (
          <div>
            {`${address.country}, ${address.province}, ${address.cityOrTown} `}
          </div>
        )

      }
    },
    {
      title: "Email Address",
      dataIndex: "email",
      key: "email"
    },
    {
      title: "Contribution",
      dataIndex: "contributions",
      key: "contribution",
      render: (detailContributions) => (
        <>
          {detailContributions.map((contribution) => {
            let color = contribution.key === 10 ? 'geekblue' : contribution.key === 11 ? 'green' : contribution.key === 12 ? 'blue' : contribution.key === 13 ? 'red' : 'cyan';
            return (
              <Tag color={color} key={contribution.key}>
                {contribution.value}
              </Tag>
            );
          })}
        </>
      ),
    },
  ];

  useEffect(() => {
    loadOrganisations()
  }, [])

  const loadOrganisations = () => {
    setOrganisations(data)
  }

  return (
    <>
      <Table
        dataSource={organisations}
        columns={columns}
        rowKey={(x) => x.name}
        bordered
        pagination={{ pageSize: 10 }}
      />
    </>
  )
}
